export default {
  title: 'Familie-tijd!',

  description:
    'Wat tof dat je Familie Avatars gaat maken. Laten we snel beginnen! En wil je later nog iets aanpassen? Dat kan altijd.'
};
